import { bluredContentModule } from '@/store/modules/blured-content.module'
import { PAGES } from '@/types/router'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { appModule } from '@/store/modules/app.module'
import DevModeButtonComponent from '../devmode-button/devmode-button.component.vue'
import EGymAddUserComponent from '../e-gym-add-user/e-gym-add-user.component.vue'
import { eGymTrainingsModule } from '@/store/modules/egym-trainings.module'
import { notificationModule } from '@/store/modules/notification.module'
import { NotificationCommand, NotificationType, UserAnswer } from '@/types/notification'
import {ctrlCmdModule} from "@/store/modules/control-commands.module";
import {CTRL_COMMAND} from "@/types/socket";
import workoutsStoreManager from "@/store/managers/workouts.store.manager";
import {eGymUsersModule} from "@/store/modules/egym-users.module";

@Component({
  components: {
    'dev-button': DevModeButtonComponent,
    'egym-add-user-component': EGymAddUserComponent
  }
})
export default class MenuOverlayComponent extends Vue {
  private linksList = [
    {
      name: 'home',
      route: PAGES.HOME
    },
    {
      name: 'velocity',
      route: PAGES.VELOCITY_WORKOUTS
    },
    {
      name: "egym_training_plans",
      route: PAGES.EGYM_TRAINING_PLANS
    },
    {
      name: "virtual_classes",
      route: PAGES.VIRTUAL_CLASSES
    },
    {
      name: 'workouts',
      route: PAGES.REGULAR_WORKOUTS
    },
    {
      name: "monthly_trainings",
      route: PAGES.MONTHLY_TRAINING_OVERVIEW
    },
    {
      name: "timers",
      route: PAGES.TIMERS
    },
    {
      name: "dev_monitor",
      route: PAGES.DEVMONITOR
    },
    {
      name: 'hyrox',
      route: PAGES.HYROX_PAGE
    },
    {
      name: 'hyrox_athlete',
      route: PAGES.HYROX_ATHLETE_PAGE
    },
    {
      name: 'exercises',
      route: PAGES.SINGLE_EXERCISE_LIBRARY
    }
  ]

  get availableLinks() {
    const links = this.linksList.slice()
    if (eGymTrainingsModule.workouts.length < 1) {
      links.splice(links.findIndex(link => link.route === PAGES.EGYM_TRAINING_PLANS), 1)
    }
    if (!appModule.virtualClassesAvailable) {
      links.splice(links.findIndex(link => link.route === PAGES.VIRTUAL_CLASSES), 1)
    }
    if (!appModule.workoutsAvailable) {
      links.splice(links.findIndex(link => link.route === PAGES.REGULAR_WORKOUTS), 1) 
    }
    if (!appModule.monthlyTrainingsAvailable) {
      links.splice(links.findIndex(link => link.route === PAGES.MONTHLY_TRAINING_OVERVIEW), 1)
    }
    if (!appModule.timersAvailable) {
      links.splice(links.findIndex(link => link.route === PAGES.TIMERS), 1)
    }
    if (!appModule.devModeOn) {
      links.splice(links.findIndex(link => link.route === PAGES.DEVMONITOR), 1)
    }
    if (!appModule.hyroxOn) {
      links.splice(links.findIndex(link => link.route === PAGES.HYROX_PAGE), 1)
    }
    if (!appModule.hyroxWorkoutsAvailable) {
      links.splice(links.findIndex(link => link.route === PAGES.HYROX_ATHLETE_PAGE), 1)
    }
    if (!appModule.velocityWorkoutsAvailable) {
      links.splice(links.findIndex(link => link.route === PAGES.VELOCITY_WORKOUTS), 1)
    }

    return links
  }

  get isItDevMenu() {
    return appModule.devModeOn
  }

  get currentRoute() {
    return this.$route.name
  }

  get isButtonVisible() {
    const routes = [
      PAGES.LOGIN, PAGES.DEVICE_CHANGING
    ]
    return !routes.some(route => route === this.$route.name)
  }

  get isMenuVisible() {
    const routes = [
      PAGES.MONTHLY_TRAINING_DESCRIPTION, PAGES.MSS_WORKOUT_DESCRIPTION,
      PAGES.REGULAR_WORKOUT_DESCRIPTION, PAGES.VIRTUAL_CLASS_DESCRIPTION,
      PAGES.ACTIVE_VIRTUAL_CLASS, PAGES.WORKOUT_ACTIVE_PAGE,
      PAGES.MSS_WORKOUT_ACTIVE_PAGE, PAGES.MONTHLY_TRAINING_ACTIVE, PAGES.TIMERS_ACTIVE,
      PAGES.EGYM_ADD_USERS, PAGES.EGYM_TRAINING_DESCRIPTION, PAGES.EGYM_TRAINING_ACTIVE,
      PAGES.HYROX_PAGE
    ]
    return !routes.some(route => route === this.$route.name)
  }

  get isContentBlured() {
    return bluredContentModule.isBlured
  }

  get isActiveLinkClasses() {
    return ['is-active']
  }

  get isInactiveLinkClasses() {
    return ['fontA-color-text']
  }
  
  get isEgymActive() {
    return appModule.eCheckInOn
  }

  get isEgymSingleUserMode() {
    return eGymUsersModule.usersCheckedIn.length == 1
  }

  get isEgymGroupUsersMode() {
    return eGymUsersModule.usersCheckedIn.length > 1
  }

  egymLogOut() {
    const watcher = notificationModule.$watch(
      m => m.answer,
      (answer: UserAnswer) => {
        this.toggleBluredContent(true)
        if (answer === UserAnswer.POSITIVE) {
          eGymUsersModule.resetToDefault()
          eGymTrainingsModule.resetToDefault()
          workoutsStoreManager.deleteEgymTrainings()
          ctrlCmdModule.triggerCtrlCmd({ trigger: CTRL_COMMAND.RESET_EGYM_TRAINING_PLANS, value: { id: 'none' } })
          watcher()
        }
      })
    notificationModule.showNotification({ command: NotificationCommand.EGYM_LOGOUT, type: NotificationType.CONFIRM })
  }
  

  menuIcon(linkName: string, isActive: string){
    if(linkName === this.$t('common.home')){
      if(isActive === PAGES.HOME){
        return "icon-Home"
      }else {
        return "icon-notactive_home"
      }
    }else if(linkName === "virtual_classes"){
      if(isActive === PAGES.VIRTUAL_CLASSES){
        return "icon-OnDemand"
      }else {
        return "icon-notactive_On_Demand"
      }
    }else if(linkName === 'egym_training_plans'){
      if(isActive === PAGES.EGYM_TRAINING_PLANS){
        return "icon-Training"
      } else {
        return "icon-notactive_training"
      }
    }else if(linkName === this.$t('workouts.workouts') || linkName == 'hyrox_athlete'){
      if(isActive === PAGES.REGULAR_WORKOUTS){
        return "icon-Training"
      } else {
        return "icon-notactive_training"
      }
    }else if(linkName === "monthly_trainings"){
      if(isActive === PAGES.MONTHLY_TRAINING_OVERVIEW){
        return "icon-Circuit"
      }else {
        return "icon-notactive_circuit"
      }
    } else if(linkName === "timers") {
      return "icon-icon_stopwatch"
    } else if (linkName === "hyrox") {
      if (isActive === PAGES.HYROX_PAGE) {
        return "icon-Training";
      } else {
        return "icon-notactive_training";
      }
    } else if (linkName === "velocity") {
      if (isActive === PAGES.VELOCITY_WORKOUTS) {
        return "icon-Training";
      } else {
        return "icon-notactive_training";
      }
    } else if (linkName === "exercises") {
      if (isActive === PAGES.VELOCITY_WORKOUTS) {
        return "icon-Training";
      } else {
        return "icon-notactive_training";
      }
    } else {
      return "";
    }
  }

  toggleBluredContent(isMenuOpened: boolean) {
    bluredContentModule.toggleStatus(isMenuOpened)
  }

  goToHomePage() {
    const routes = [PAGES.ACTIVE_VIRTUAL_CLASS, PAGES.WORKOUT_ACTIVE_PAGE,
      PAGES.MSS_WORKOUT_ACTIVE_PAGE, PAGES.MONTHLY_TRAINING_ACTIVE]
      if( !routes.some(route => route === this.$route.name)) {
        this.$router.push({name: PAGES.HOME})
      }
  }
}